"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var utils_1 = require("@vidazoo/ui/lib/components/utils");
var utils_2 = require("@vidazoo/ui/lib/components/utils");
var __1 = require("../");
var _ = require("lodash");
var moment = require("moment");
var modalWindowStyleFactory = function (maxWidth, maxHeight) { return ({
    maxWidth: utils_2.toREMString(maxWidth),
    maxHeight: utils_2.toREMString(maxHeight)
}); };
var ExpandablePanel = /** @class */ (function (_super) {
    tslib_1.__extends(ExpandablePanel, _super);
    function ExpandablePanel(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.checkVisibility = _.throttle(function () {
            utils_1.caf(_this.rafId);
            _this.rafId = utils_1.raf(function () {
                var isVisible = false;
                if (_this.el) {
                    var _a = _this.el.getBoundingClientRect(), height = _a.height, top_1 = _a.top;
                    var innerHeight_1 = window.innerHeight;
                    var middleY = height / 2;
                    var position = top_1 + middleY;
                    if (position > 0 && position < innerHeight_1) {
                        isVisible = true;
                    }
                }
                isVisible && _this.onViewPortVisibility();
            });
        }, 250);
        _this.toggleExpand = function () {
            _this.setState({
                isExpanded: !_this.state.isExpanded
            }, function () {
                if (_this.state.isExpanded && !_this.isVisibleOnce) {
                    _this.onViewPortVisibility();
                }
            });
        };
        _this.createRef = function (el) {
            _this.el = el;
        };
        _this.state = { isExpanded: false };
        _this.isVisibleOnce = false;
        _this.rafId = null;
        _this.el = null;
        return _this;
    }
    ExpandablePanel.prototype.componentDidMount = function () {
        if (this.props.onceViewportVisibility) {
            window.addEventListener("scroll", this.checkVisibility, { passive: true });
            window.addEventListener("resize", this.checkVisibility, { passive: true });
            this.checkVisibility();
        }
    };
    ExpandablePanel.prototype.onViewPortVisibility = function () {
        var onceViewportVisibility = this.props.onceViewportVisibility;
        this.isVisibleOnce = true;
        window.removeEventListener("scroll", this.checkVisibility);
        window.removeEventListener("resize", this.checkVisibility);
        onceViewportVisibility && onceViewportVisibility();
    };
    ExpandablePanel.prototype.renderContent = function (isExpanded) {
        var _a = this.props, children = _a.children, isLoading = _a.isLoading, renderContent = _a.renderContent;
        return isLoading
            ? React.createElement(__1.SpreadPageLoader, { blue: true })
            : typeof (renderContent) === "function"
                ? renderContent(isExpanded, this.isVisibleOnce)
                : children;
    };
    ExpandablePanel.prototype.render = function () {
        var _a = this.props, title = _a.title, modalMaxWidth = _a.modalMaxWidth, modalMaxHeight = _a.modalMaxHeight, lastRefresh = _a.lastRefresh;
        var isExpanded = this.state.isExpanded;
        return (React.createElement(ui_1.Panel, { title: title, actionIconName: "icon-expand-small", onAction: this.toggleExpand, className: theme.panel },
            lastRefresh ? (React.createElement(ui_1.Label, { weight: 200, uppercase: false, block: false }, "Data from " + moment(lastRefresh).fromNow())) : null,
            React.createElement("div", { ref: this.createRef }, this.renderContent(false)),
            React.createElement(ui_1.Modal, { panel: true, windowClass: theme.modal, windowStyle: modalWindowStyleFactory(modalMaxWidth, modalMaxHeight), title: title, isOpen: isExpanded, onClose: this.toggleExpand }, isExpanded ? this.renderContent(true) : null)));
    };
    ExpandablePanel.defaultProps = {
        modalMaxWidth: 67.5,
        modalMaxHeight: 60.6
    };
    return ExpandablePanel;
}(React.Component));
exports.default = ExpandablePanel;
